export default "__VITE_ASSET__ClogZCQj__"